import React from 'react';
import './StockLoader.css';

export default function StockLoader({ size = 28, stroke = '#2b9af3', className = '' }) {
    const s = size;
    return (
        <div className={`stock-loader ${className}`} style={{ width: s, height: s }}>
            <svg viewBox="0 0 64 64" width={s} height={s} aria-hidden>
                <defs>
                    <linearGradient id="g1" x1="0" x2="1">
                        <stop offset="0%" stopColor={stroke} stopOpacity="0.25" />
                        <stop offset="100%" stopColor={stroke} stopOpacity="1" />
                    </linearGradient>
                </defs>
                <polyline
                    className="line-anim"
                    points="6,48 16,38 24,44 34,30 44,34 54,12"
                    fill="none"
                    stroke="url(#g1)"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <polygon className="arrow-anim" points="54,12 50,18 58,18" fill={stroke} />
            </svg>
        </div>
    );
}